import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const propTypes = {
    /** Label's contents, usually text */
    children: PropTypes.node.isRequired,

    /** The id of the input being labeled */
    htmlFor: PropTypes.string.isRequired,

    /** Adds the required asterisk */
    isRequired: PropTypes.bool,

    /** Makes the label screen-reader only */
    isVisible: PropTypes.bool,

    /** Accepts a custom className that will be merged in with other classes */
    className: PropTypes.string
};


const defaultProps = {
    className: null,
    isRequired: false,
    isVisible: true
};

export default function Label(props) {
    const { children, htmlFor, className, isRequired, isVisible, ...rest } = props;

    const classes = cx('sarsa-label', className, {
        'rec-sr-only': !isVisible,
        'sarsa-label-required': isRequired
    });

    return (
        <label
            data-component="Label"
            id={`${htmlFor}-label`}
            className={classes}
            htmlFor={htmlFor}
            {...rest}>
            {children}
            {isRequired && (
                <abbr className="rec-label-required-indicator">
                    <span aria-hidden="true">*</span>
                    <span className="rec-sr-only"> (Required) </span>
                </abbr>
            )}
        </label>
    );
}

Label.propTypes = propTypes;
Label.defaultProps = defaultProps;